import React, { Component } from "react";

import StoryCard from "../../../components/Library/StoryCard";
import NewsletterHeader from "../NewsletterHeader";

import styles from "./Newsletter.css";

class Newsletter extends Component {

  componentDidMount() {
    let hash = window.location.hash;
    if (hash !== "") {
      const element = document.getElementById(hash.slice(1));
      if (element) {
        setTimeout(() => element.scrollIntoView(), 2000);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }

  render() {
    const { newsletter } = this.props;
    if (!newsletter) return null;

    return (
      <div>
        <StoryCard
          key={`intro-${newsletter.id}`}
          hideFooter={true}
          className={styles.story}
          header={<NewsletterHeader newsletter={newsletter}/>}
          story={{ blocks: newsletter.intro }}/>

        {newsletter.chunks.map((chunk, index) =>
          <div key={chunk.id}>
            <div id={`story${index}`} className={styles.anchor}/>
            <StoryCard
              story={chunk}
              className={styles.story}
              hideHeader={true}/>
          </div>)}

        <StoryCard
          key={`outro-${newsletter.id}`}
          hideHeader={true}
          hideFooter={true}
          className={styles.footer}
          story={{ blocks: newsletter.outro }}/>
      </div>
    );
  }
}

export default Newsletter;



// WEBPACK FOOTER //
// ./src/subscriptions/components/Newsletter/Newsletter.js